import { useEffect, useState } from 'react';

import ListAppointmentPage from '../../../presentation/page/listAppointment/ListAppointmentPage';

import { UseAlert } from '../../../presentation/hook/AlertHook';
import { UseLoader } from '../../../presentation/hook/LoaderHook';

import { FormatDate } from '../../../main/helper/dateFormatter';

import { AddAppointment, EditAppointment } from '../../../presentation/page/listAppointment/ListAppointmentPageType';

import { AppointmentUseCase } from '../../../data/useCase/AppointmentUseCase';
import { ProfessionalUseCase } from '../../../data/useCase/ProfessionalUseCase';
import { PatientUseCase } from '../../../data/useCase/PatientUseCase';
import MessageConstant from '../../../main/constant/MessageConstant';
import { HttpStatusCodeEnum } from '../../enums/HttpStatusCodeEnum';
import { UseAuth } from '../../../presentation/hook/AuthHook';
import { ProfilesConstant } from '../../../main/constant/ProfilesConstant';
import { EndpointsConstant } from '../../../main/constant/EndpointConstant';

export const ListAppointmentPageDomain: React.FC = () => {
  /**
   * Perfil de acesso
   */
  const PROFILE_DENTISTA = ProfilesConstant.dentist;
  const PROFILE_RECEPCIONISTA = ProfilesConstant.receptionist;

  /**
   * Alertas
   */
  const { showAlert } = UseAlert();

  /**
   * dados do usuario logado no localstorage
   */
  const { loggedUserData } = UseAuth();
  const userRoles = loggedUserData?.roles || [];
  const ROLE_PROFESSIONAL = PROFILE_DENTISTA;
  const roleIsProfessional = userRoles.includes(ROLE_PROFESSIONAL);
  const ROLE_RECEPCIONISTA = PROFILE_RECEPCIONISTA;

  /**
   * loading
   */
  const { setLoad } = UseLoader();

  /**
   * endpoint
   */
  const ENDPOINT_APPOINTMENTS = EndpointsConstant.appointments;
  const ENDPOINT_PROFESSIONAL = EndpointsConstant.professional;
  const ENDPOINT_PATIENT = EndpointsConstant.patient;

  /**
   * model
   */
  const [listProfessional, setListProfessional] = useState<[]>([]);
  const [listPatient, setListPatient] = useState<[]>([]);

  /**
   * model
   */
  const [appointment, setAppointment] = useState<null>(null);

  /**
   * add
   * @param params
   */
  const add = async (params: AddAppointment) => {
    setLoad(true);

    const findProfessional: any = listProfessional.filter((item: any) => item.id == params.professionalId);

    const findPatient: any = listPatient.filter((item: any) => item.id == params.patientId);

    const modelRequest = {
      status: params.status === '' ? 'N' : params.status,
      patientId: params.patientId,
      patientName: findPatient.length > 0 ? findPatient[0].name : '',
      professionalId: params.professionalId,
      professionalName: findProfessional.length > 0 ? findProfessional[0].name : '',
      start: FormatDate.formatDateTime(params.dateAppointment ?? '', params.start),
      end: FormatDate.formatDateTime(params.dateAppointment ?? '', params.end),
      chair: Number(params.chair),
      observation: params.observation,
    };

    await new AppointmentUseCase(`${ENDPOINT_APPOINTMENTS}`)
      .Post({ data: modelRequest })
      .then((response) => {
        console.info('RESPONSE: ', response);
        if (response.statusCode !== undefined) {
          if (response.statusCode === HttpStatusCodeEnum.ok) {
            showAlert({
              show: true,
              content: MessageConstant.sucesso.criar,
              color: 'success',
              time: 2000,
            });
          } else {
            response.body.forEach((item: any) => {
              showAlert({
                show: true,
                content: item.errorMessage,
                color: 'warning',
                time: 2000,
              });
            });
          }
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      })
      .catch((error) => {
        console.error('ERRO: ', error);
        if (error.response.status === HttpStatusCodeEnum.badRequest) {
          error.response.data.forEach((item: any) => {
            showAlert({
              show: true,
              content: item.errorMessage,
              color: 'warning',
              time: 2000,
            });
          });
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      });

    setLoad(false);
  };

  /**
   * edit
   * @param params
   */
  const edit = async (params: EditAppointment) => {
    setLoad(true);

    const findProfessional: any = listProfessional.filter((item: any) => item.id == params.professionalId);
    const findPatient: any = listPatient.filter((item: any) => item.id == params.patientId);

    const modelRequest = {
      status: params.status === '' ? 'A' : params.status,
      patientId: params.patientId,
      patientName: findPatient.length > 0 ? findPatient[0].name : '',
      professionalId: params.professionalId,
      professionalName: findProfessional.length > 0 ? findProfessional[0].name : '',
      start: FormatDate.formatDateTime(params.dateAppointment ?? '', params.start),
      end: FormatDate.formatDateTime(params.dateAppointment ?? '', params.end),
      chair: Number(params.chair),
      observation: params.observation,
    };

    await new AppointmentUseCase(`${ENDPOINT_APPOINTMENTS}/${params.id}`)
      .Put({ data: modelRequest })
      .then((response) => {
        console.info('RESPONSE: ', response);
        if (response.statusCode !== undefined) {
          if (response.statusCode === HttpStatusCodeEnum.ok) {
            showAlert({
              show: true,
              content: MessageConstant.sucesso.criar,
              color: 'success',
              time: 2000,
            });
          } else {
            response.body.forEach((item: any) => {
              showAlert({
                show: true,
                content: item.errorMessage,
                color: 'warning',
                time: 2000,
              });
            });
          }
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      })
      .catch((error) => {
        console.error('ERRO: ', error);
        if (error.response.status === HttpStatusCodeEnum.badRequest) {
          error.response.data.forEach((item: any) => {
            showAlert({
              show: true,
              content: item.errorMessage,
              color: 'warning',
              time: 2000,
            });
          });
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      });

    setLoad(false);
  };

  /**
   * getPatient
   * @param id
   */
  const getAppointment = async (id: number) => {
    setLoad(true);

    if (id !== undefined || id !== null) {
      await new AppointmentUseCase(`${ENDPOINT_APPOINTMENTS}/${id}`)
        .Get()
        .then((response) => {
          setAppointment(response.body);
        })
        .catch((error) => {
          console.error('ERRO: ', error);
          if (error.response.status === HttpStatusCodeEnum.badRequest) {
            error.response.data.forEach((item: any) => {
              showAlert({
                show: true,
                content: item.errorMessage,
                color: 'warning',
                time: 2000,
              });
            });
          } else {
            showAlert({
              show: true,
              content: MessageConstant.erro.generico,
              color: 'danger',
              time: 2000,
            });
          }
        });
    }
    setLoad(false);
  };

  /**
   * getListProfessional
   */
  const getListProfessional = async () => {
    setLoad(true);

    await new ProfessionalUseCase(`${ENDPOINT_PROFESSIONAL}?page=0&pageSize=1000&status=Ativos`)
      .Get()
      .then((response: any) => {
        let listProfissional: [] = [];
        if (response.body.totalCount > 0) {
          const list = response.body.items
            .filter((item: any) => {
              if (item.profileDescription !== ROLE_RECEPCIONISTA) {
                if (roleIsProfessional) {
                  if (item.name === loggedUserData?.name) {
                    return item;
                  }
                } else {
                  return item;
                }
              }
            })
            .map((item: any) => {
              return {
                name: item.name,
                id: item.id,
              };
            });
          listProfissional = list;
        }
        setListProfessional(listProfissional);
      })
      .catch((error) => {
        console.error('ERRO: ', error);
        if (error.response.status === HttpStatusCodeEnum.badRequest) {
          error.response.data.forEach((item: any) => {
            showAlert({
              show: true,
              content: item.errorMessage,
              color: 'warning',
              time: 2000,
            });
          });
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      });
    setLoad(false);
  };

  /**
   * getListPatient
   */
  const getListPatient = async () => {
    setLoad(true);
    await new PatientUseCase(`${ENDPOINT_PATIENT}/enumeration`)
      .Get()
      .then((response: any) => {
        setListPatient(response.body);
      })
      .catch((error) => {
        console.error('ERRO: ', error);
        if (error.response.status === HttpStatusCodeEnum.badRequest) {
          error.response.data.forEach((item: any) => {
            showAlert({
              show: true,
              content: item.errorMessage,
              color: 'warning',
              time: 2000,
            });
          });
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      });
    setLoad(false);
  };

  /**
   *
   */
  useEffect(() => {
    getListProfessional();
    getListPatient();
  }, []);

  return (
    <>
      <ListAppointmentPage
        add={add}
        getAppointment={getAppointment}
        appointment={appointment}
        edit={edit}
        listPatient={listPatient}
        listProfessional={listProfessional}
      />
    </>
  );
};
